import React from 'react';

const baseCanonicalUrl = 'https://www.owndays.com/sg/en/news';
const fancyBoxScript = (
  <>
    <link href="https://cdn.jsdelivr.net/npm/@fancyapps/ui@4/dist/fancybox.css" rel="stylesheet" />
    <script src="https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js"></script>
  </>
);

export const NEWS = [
  {
    metaTitle: 'OWNDAYS PROGRESSIVE GLASSES | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/progressive-cp',
    keywords:
      'Free Progressive lenses,Progressive lens price Singapore,Progressive lens Singapore,Progressive glasses,Spectacle frames,What are progressive lenses,Best progressive lenses Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/progressive-cp/ogp-10-2024.webp',
    description: `Free Enhanced Progressive Lens with spectacle purchase for all customers; just one pair of glasses to see far, intermediate and reading zones`,
    canonicalUrl: `${baseCanonicalUrl}/progressive-cp`,
  },
  {
    metaTitle: 'Harry Potter × OWNDAYS | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/harry-potter',
    keywords:
      'Harry Potter,OWNDAYS,eyewear,collection,magic,wand,broomstick,deathly hallows,symbol,glasses,cleaning cloth,nimbus 2000,golden snitch,quidditch, Hermione,Hogwarts,Hogwarts Express,lineup,exclusive merchandise',
    ogImage: 'https://static.lenskart.com/owndays/img/harry-potter/ogp_1200x630.jpg',
    description: `Harry Potter × OWNDAYS eyewear collection inspired by meticulously crafted magical objects and symbolic patterns.`,
    canonicalUrl: `${baseCanonicalUrl}/harry-potter`,
    otherScript: <script src="https://use.typekit.net/rjg3xux.js" />,
  },
  {
    metaTitle:
      '【SOLD OUT】ZEON EXCLUSIVE SPECTACLES & SUNGLASSES | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/gundam5-zeon',
    keywords:
      'Mobile Suit Gundam,Principality of Zeon,Char Custom,Zaku,collaboration,frames,owndays,spectacles,glasses,eye glasses',
    ogImage: 'https://static.lenskart.com/owndays/img/gundam5-zeon/ogp_1200x630.jpg',
    description: `From Mobile Suit Gundam, one of the most iconic Japanese anime series that has remained highly popular across generations, comes an eyewear collaboration focusing on the Principality of Zeon. The lineup consists of a spectacle model and a sunglass model.`,
    canonicalUrl: `${baseCanonicalUrl}/gundam5-zeon`,
  },
  {
    metaTitle: '【SOLD OUT】ZEON × OWNDAYS ZAKU HEAD CASE | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/gundam5-zakuhead',
    keywords: 'Gundam,Zeon,Head,Zack,case,collaboration,eyeglasses,sunglasses,OWNDAYS,Singapore',
    ogImage: 'https://static.lenskart.com/owndays/img/gundam5-zakuhead/ogp_1200x630.jpg',
    description: `From Mobile Suit Gundam, one of the most iconic Japanese anime series that has transcended generations, comes the Zaku Head Case, an eyewear storage case modelled after Char Aznable’s custom Zaku in the largest-ever 1:7 scale.`,
    canonicalUrl: `${baseCanonicalUrl}/gundam5-zakuhead`,
  },
  {
    metaTitle: 'GUNDAM × OWNDAYS | OWNDAYS Singapore',
    targetPath: '/news/gundam',
    keywords:
      'GUNDAM,40th,collaboration,project,head case,frames,owndays,spectacles,glasses,eye glasses',
    ogImage: 'https://static1.lenskart.com/owndays/img/specials/products/gundam/ogp_1200x630-2.jpg',
    description:
      'Explore the GUNDAM × OWNDAYS collaboration in Singapore. Discover stylish eyewear inspired by GUNDAM. Get yours today and show your love for the iconic series!',
    canonicalUrl: `${baseCanonicalUrl}/gundam`,
  },
  {
    metaTitle: 'OWNDAYS × HUAWEI Eyewear2 | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/huawei2',
    keywords:
      'HUAWEI Eyewear2,HUAWEI2,OWNDAYS × HUAWEI Eyewear2,HUAWEI Eyewear,HUAWEI Smart Audio Glasses,HUAWEI sunglasses,SNAP,Collaboration,New Models,glasses,sunglasses,Singapore,2025,OWNDAYS',
    ogImage: 'https://static.lenskart.com/owndays/img/huawei2-titanium/ogp_1200x630.webp',
    description: `Introducing the Titanium Edition of the OWNDAYS × HUAWEI Eyewear 2 Smart Audio Glasses. With this addition, the collection now features six models, each available in two colour variations. Designed for an enhanced auditory and visual experience, these smart audio glasses offer improved sound quality while weighing lighter than previous generation.`,
    canonicalUrl: `${baseCanonicalUrl}/huawei2`,
    otherScript: fancyBoxScript,
  },
  {
    metaTitle: 'OWNDAYS Contact Lens Promotion | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/bundle-sale',
    keywords:
      'Contact Lens,OWNDAYS contact lens,colour contact lens,clear contact lens,contact lenses,contact lens singapore,contact lens sale,contact lens promo,daily contact lens,monthly contact lens,contact lens daily,contact lens monthly',
    ogImage:
      'https://static.lenskart.com/media/img/news/owndays-contact-lens-promotion/ogp_1200x630.jpg',
    description: `Grab exclusive contact lens bundles: Get $10 off 4 boxes or $30 off 8 boxes of clear lenses and 1 box free for every 7 boxes of color lenses. While stocks last!`,
    canonicalUrl: `${baseCanonicalUrl}/bundle-sale`,
    otherScript: fancyBoxScript,
  },
  {
    metaTitle: 'Free Myopia Control 2 Lenses | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/free-myopia-control-2-lenses',
    keywords:
      'spectacles,myopia,manage child myopia,eyeglasses,free lens upgrade,myopia control lens,prescription glasses Singapore,book an eye test,OWNDAYS',
    ogImage:
      'https://static.lenskart.com/owndays/img/news/free-myopia-control-2-lenses/ogp_1200x630-20250408.jpg',
    description: `Get FREE Myopia Control 2 Lenses for kids aged 14 and below with any spectacles purchase at OWNDAYS. Slow down myopia progression by up to 50%. Learn more today!`,
    canonicalUrl: `${baseCanonicalUrl}/free-myopia-control-2-lenses`,
  },
  {
    metaTitle: 'OWNDAYS Ortho-K Webinar | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/ortho-k-webinar',
    keywords:
      'Ortho-K,contact lens,webinar,child,orthokeratology,online,event,November,2024,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/ortho-k-webinar/ogp_1200x630.webp',
    description: `Sign up for a complimentary webinar to learn how Ortho-K offers spectacle-free vision and help slow down myopia progression for children.`,
    canonicalUrl: `${baseCanonicalUrl}/ortho-k-webinar`,
    otherScript: fancyBoxScript,
  },
  {
    metaTitle: 'Pop-Up Event at VivoCity | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/vivocity-event',
    keywords:
      'VivoCity,Pop-Up Event at VivoCity,70%OFF,eyewear,spectacle frames,sunglasses,eco-bags,mascot,Mega-Kuma,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/news/vivocity-event/ogp_1200x630.jpg',
    description: `Join us at our Pop-Up Event at VivoCity Level 1 Atrium for unbeatable deals on our spectacle frames and try your luck at winning fabulous prizes (terms & conditions apply). Whether you are a fashion-forward person, a savvy shopper or just looking to refresh your eyewear, we have something special for everyone. See you there!`,
    canonicalUrl: `${baseCanonicalUrl}/vivocity-event`,
  },
  {
    metaTitle: '1-for-1 Contact Lens Offer | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/contact-lens-deal',
    keywords: '1-for-1,contactlens,clear,daily,monthly,blue,UV,Singapore,OWNDAYS',
    ogImage:
      'https://static.lenskart.com/media/owndays/img/owndays-1-for-1-contact-lens-deal/ogp_1200x630.webp',
    description: `Unlock incredible savings with our 1-for-1 clear contact lens deal. Exclusively for new contact lens customers.`,
    canonicalUrl: `${baseCanonicalUrl}/contact-lens-deal`,
  },
  {
    metaTitle: 'OWNDAYS PC | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/owndayspc',
    keywords:
      'owndayspc,spectacles,glasses,optical shop,eye glasses,sunglasses,eyewear,pc lenses,frame,bluelight,filter blue light,owndays',
    ogImage: 'https://static.lenskart.com/media/owndays/img/owndays-pc/ogp_1200x630.webp',
    description: `OWNDAYS PC - SAVE YOUR EYES, SHIELD YOUR EYES! Reduce up to 25% blue light!`,
    canonicalUrl: `${baseCanonicalUrl}/owndayspc`,
  },
  {
    metaTitle: 'Kuromi × OWNDAYS | OWNDAYS Singapore Online Store',
    targetPath: '/news/kuromi',
    keywords:
      'Kuromi,Baku,sanrio,Character,Sanrio Characters,Collaboration,glasses,character,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/kuromi-collection/ogp_1200x630.webp',
    description: `Explore Kuromi × OWNDAYS stylish and cute eyewear collection, inspired by Kuromi and Baku. Find unique and expressive spectacle frames to express your style!`,
    canonicalUrl: `${baseCanonicalUrl}/kuromi`,
  },
  {
    metaTitle: 'SHINGO AIBA × OWNDAYS EYEWEAR COLLECTION | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/shingo-aiba',
    keywords:
      '相場慎吾,SHINGO AIBA,SAINT LAURENT,Limited Edition,collaboration,glasses,Lens Replacement,onlineshop,onlinestore,OWNDAYS',
    ogImage:
      'https://static1.lenskart.com/owndays/img/specials/products/shingo-aiba/ogp_1200x630-2.jpg',
    description:
      'A capsule collection created in collaboration with Japanese designer, Shingo Aiba whose credentials include a tenure in a global fashion house in Paris.',
    canonicalUrl: `${baseCanonicalUrl}/shingo-aiba`,
  },
  {
    metaTitle: `OWNDAYS × FREAK'S STORE | OWNDAYS ONLINE STORE - OPTICAL SHOP`,
    targetPath: '/news/freaks-store',
    keywords: `FREAK'S STORE,life style,collaboration,select store,Japan,photochromic,folding,polarized,sunglasses,eyeframe,eyeglasses,lens,case,cloth,online store,Singapore`,
    ogImage: 'https://static.lenskart.com/owndays/img/freaks-store-2025/ogp_1200x630.webp',
    description: `Back by popular demand, our 2nd collection is here! Featuring sunglasses in stylish design with functional lens options such as Transitions and Polarised lenses, this lineup blends functionality with trendiness to suit any scene.`,
    canonicalUrl: `${baseCanonicalUrl}/freaks-store`,
    otherScript: fancyBoxScript,
  },
  {
    metaTitle: 'AIR Ultem | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/airultem',
    keywords:
      'OWNDAYS,AIRULTEM,eyeglasses,sunglasses,eyeframe,lens,light,resin,metal,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/air/ogp_1200x630.webp',
    description: `Engineered with ultra-lightweight and highly durable materials to deliver a wearing comfort that feels like air, these spectacle frames offer an impeccable fit and can be worn comfortably for long hours.`,
    canonicalUrl: `${baseCanonicalUrl}/airultem`,
  },
  {
    metaTitle: 'OWNDAYS | AIR | Incredibly Lightweight, The Durability You Can Rely On',
    targetPath: '/news/air',
    keywords: 'OWNDAYS,AIR,eyeglasses,sunglasses,eyeframe,lens,light,resin,metal,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/air/ogp_1200x630.webp',
    description: `Engineered with ultra-lightweight and highly durable materials to deliver a wearing comfort that feels like air, these spectacle frames offer an impeccable fit and can be worn comfortably for long hours.`,
    canonicalUrl: `${baseCanonicalUrl}/air`,
    otherScript: fancyBoxScript,
  },
  {
    metaTitle: 'Demon Slayer: Kimetsu no Yaiba × OWNDAYS | OWNDAYS Singapore',
    targetPath: '/news/kimetsu',
    keywords:
      'Demon Slayer,Kimetsu no Yaiba,CHARACTER FRAME COLLECTION,ORIGINAL,Tanjiro,Nezuko,Zenitsu,Inosuke,Giyu,Shinobu,Nichirin Sword,iconic patterns,outfit,spectacles,glasses,eye glasses',
    ogImage: 'https://static.lenskart.com/media/owndays/img/kimetsu/ogp_1200x630.webp',
    description: `Discover six unique spectacle frames inspired by the characters from Demon Slayer: Kimetsu no Yaiba. Each frame embodies the essence of a character's iconic patterns.`,
    canonicalUrl: `${baseCanonicalUrl}/kimetsu`,
  },
  {
    metaTitle: 'OWNDAYS & POMPOMPURIN',
    targetPath: '/news/pompompurin',
    keywords:
      'POMPOMPURIN,sanrio,pudding,lineup,collaboration,eyeglasses,sunglasses,snap,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/pompompurin/ogp_1200x630.webp',
    description: `Presenting the spectacle frame collaboration with POMPOMPURIN. It’s cuteness overload with these spectacle frames featuring Pompompurin, the boy golden retriever with his trademark brown beret. Whether you’re out and about or relaxing at home, pick your favourable pair and keep Pompompurin by your side at all time!`,
    canonicalUrl: `${baseCanonicalUrl}/pompompurin`,
  },
  {
    metaTitle: 'Handcrafted Senichisaku Frames | OWNDAYS Singapore',
    targetPath: '/news/senichisaku',
    keywords:
      '千一作,SENICHISAKU,Sabae,Made in Japan,celluloid,glasses,sunglasses,onlineshop,onlinestore',
    ogImage: 'https://static.lenskart.com/owndays/img/senichisaku/ogp_1200x630.webp',
    description: `Discover the art of Senichisaku frames, meticulously handcrafted in the City of Eyewear, Sabae. Experience the unique, enriching color and unmatched durability.`,
    canonicalUrl: `${baseCanonicalUrl}/senichisaku`,
  },
  {
    metaTitle: '10th Anniversary Collection | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/10th-anniversary-collection',
    keywords:
      '10thAnniversaryCollection,Singapore,since0713,glasses,sunglasses,lenses,eyewear,lineup,OWNDAYS',
    ogImage:
      'https://static.lenskart.com/owndays/img/anniversary-10th-collection/ogp_1200x630.webp',
    description: `A commemorative collection to mark 10 amazing years in Singapore, featuring frame designs created specifically for the discerning local customers who manifest in the love for tasteful yet functional eyewear.`,
    canonicalUrl: `${baseCanonicalUrl}/10th-anniversary-collection`,
    otherScript: fancyBoxScript,
  },
  {
    metaTitle: 'OWNDAYS | SUN',
    targetPath: '/news/sun',
    keywords:
      'OWNDAYS | SUN,sunglasses,snap,clearsunglasses,newarrivals,frames,colour,tranisiton,polarised,lensesSingapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/owndays/img/sun/ogp_1200x630.jpg',
    description: `Where fashion meets function. With SUN by your side, every moment becomes extra special.`,
    canonicalUrl: `${baseCanonicalUrl}/sun`,
    otherScript: fancyBoxScript,
  },
  {
    metaTitle: 'TOM and JERRY × OWNDAYS',
    targetPath: '/news/tomandjerry',
    keywords:
      'TOM and JERRY,character,Warner Bros,collaboration,SNAP,eyeglasses,sunglasses,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/owndays/img/tomandjerry/ogp_1200x630.webp',
    description: `Discover the collection inspired by Tom and Jerry, the beloved slapstick cartoon comedy starring the iconic duo in an endless game of cat-and-mouse! This collaboration captures their playful dynamic - a true friendship wrapped in constant mischief. Packed with hidden surprises, they are sure to leave you smiling.`,
    canonicalUrl: `${baseCanonicalUrl}/tomandjerry`,
  },
  {
    metaTitle: 'Celebrate 500 Stores Worldwide | OWNDAYS Singapore',
    targetPath: '/news/500stores',
    keywords:
      'Celebrating 500 stores worldwide,Commemorative frame,glasses,spectacles,optical shop,online store,eyeglasses,OWNDAYS,frame,sunglasses,pc lenses',
    ogImage: 'https://static.lenskart.com/owndays/img/specials/products/stores500/ogp_1200x630.jpg',
    description:
      "Join us in celebrating OWNDAYS' achievement of 500 stores worldwide with a commemorative eyewear collection. Enjoy 'Made-in-Japan' quality at an exceptional price.",
    canonicalUrl: `${baseCanonicalUrl}/500stores`,
  },
  {
    metaTitle: 'OWNDAYS MEETS: #14 Dawn Yeoh | OWNDAYS Singapore',
    targetPath: '/news/owndays-meets-201701',
    keywords:
      'Dawn Yeoh,artiste,OWNDAYS MEETS,spectacles,glasses,optical shop,eye glasses,sunglasses,eyewear,pc lenses,frame',
    ogImage:
      'https://static1.lenskart.com/owndays/img/specials/owndays-meets/201701/ogp_1200x630.jpg',
    description:
      'Delve into the world of Dawn Yeoh, Singaporean artiste, in Part 14 of OWNDAYS MEETS. Uncover her career path, passion, and future aspirations in the arts and beyond.',
    canonicalUrl: `${baseCanonicalUrl}/owndays-meets-201701`,
  },
  {
    metaTitle: 'mi-mollet × OWNDAYS | OWNDAYS Singapore Online Store',
    targetPath: '/news/mi-mollet',
    keywords: 'mi-mollet,NaokoOkusa,naoko-okusa,collaboration,glasses,online-store,in-store',
    ogImage:
      'https://static1.lenskart.com/owndays/img/specials/products/mi-mollet/ogp_1200x630-2.jpg',
    description:
      'Explore the stylish spectacle frames by Naoko Okusa, a collaboration between mi-mollet and OWNDAYS, where fashion meets functionality effortlessly. Shop now.',
    canonicalUrl: `${baseCanonicalUrl}/mi-mollet`,
  },
  {
    metaTitle: 'OWNDAYS MEETS: #16 Ham Tran | OWNDAYS Singapore',
    targetPath: '/news/owndays-meets-201702-3',
    keywords:
      'Ham Tran,Film Producer,OWNDAYS MEETS,spectacles,glasses,optical shop,eye glasses,sunglasses,eyewear,pc lenses,frame',
    ogImage:
      'https://static.lenskart.com/owndays/img/specials/owndays-meets/201702-3/ogp_1200x630.jpg',
    description:
      "Explore Ham Tran's unique journey from Vietnam to Hollywood in Part 16 of OWNDAYS MEETS. Uncover his enduring pursuit of cultural identity through film.",
    canonicalUrl: `${baseCanonicalUrl}/owndays-meets-201702-3`,
  },
  {
    metaTitle: 'OWNDAYS MEETS: #15 Yuni Hadi | OWNDAYS Singapore',
    targetPath: '/news/owndays-meets-201702-2',
    keywords:
      'Yuni Hadi,Film Producer,OWNDAYS MEETS,spectacles,glasses,optical shop,eye glasses,sunglasses,eyewear,pc lenses,frame',
    ogImage:
      'https://static.lenskart.com/owndays/img/specials/owndays-meets/201702-2/ogp_1200x630.jpg',
    description:
      "Delve into Yuni Hadi's journey, a Singaporean film producer. Explore her insights on filmmaking, challenges, and the future of cinema with part 15 of OWNDAYS MEETS.",
    canonicalUrl: `${baseCanonicalUrl}/owndays-meets-201702-2`,
  },
  {
    metaTitle: 'OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/owndays-meets-201401',
    keywords:
      'YOHEI SHINOMIYA,OWNDAYS MEETS,glasses,spectacles,optical shop,eyeglasses,OWNDAYS,frame,sunglasses,eyewear Singapore',
    ogImage:
      'https://www.owndays.com/images/specials/owndays-meets/201401/ogp_1200x630.jpg?1553872743',
    description:
      '#02 YOHEI SHINOMIYA -OWNDAYS MEETS- Own Days… Each day builds on the last, and eventually they from one path.',
    canonicalUrl: `${baseCanonicalUrl}/owndays-meets-201401`,
  },
  {
    metaTitle: 'OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/owndays-meets-201312',
    keywords:
      'JUN HAGAN,OWNDAYS MEETS,glasses,spectacles,optical shop,eyeglasses,OWNDAYS,frame,sunglasses,eyewear Singapore',
    ogImage:
      'https://www.owndays.com/images/specials/owndays-meets/201312/ogp_1200x630.jpg?1553872737',
    description:
      '#01 JUN HAGAN -OWNDAYS MEETS- Own Days… Each day builds on the last, and eventually they from one path.',
    canonicalUrl: `${baseCanonicalUrl}/owndays-meets-201312`,
  },
  {
    metaTitle: 'OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/owndays-contactlens/monthly',
    keywords: 'OWNDAYS CLEAR VISION,monthly,6 lenses,soft contact lens,original',
    ogImage: 'https://www.owndays.com/images/specials/ogp_1200x630.jpg?1553872731',
    description: `OWNDAYS CLEAR VISION MONTHLY - OWNDAYS CLEAR VISION is the in-house contact lens line from OWNDAYS. With huge emphasis on quality and material, OWNDAYS CLEAR VISION allows wearers to get through their daily activities with comfortable and refreshed vision. Easy to put on and conveniently available, OWNDAYS CLEAR VISION is the perfect contact lens for everyday use!`,
    canonicalUrl: `${baseCanonicalUrl}/owndays-contactlens/monthly`,
  },
  {
    metaTitle: 'OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/owndays-meets-201312',
    keywords:
      'JUN HAGAN,OWNDAYS MEETS,glasses,spectacles,optical shop,eyeglasses,OWNDAYS,frame,sunglasses,eyewear Singapore',
    ogImage:
      'https://www.owndays.com/images/specials/owndays-meets/201312/ogp_1200x630.jpg?1553872737',
    description: `#01 JUN HAGAN -OWNDAYS MEETS- Own Days… Each day builds on the last, and eventually they from one path.`,
    canonicalUrl: `${baseCanonicalUrl}/owndays-meets-201312`,
  },
  {
    metaTitle: 'OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/owndays-meets-201905',
    keywords:
      'HIROTADA OTOTAKE,Writer,OWNDAYS MEETS,spectacles,glasses,optical shop,eye glasses,sunglasses,eyewear,pc lenses,frame',
    ogImage:
      'https://www.owndays.com/images/specials/owndays-meets/201905/ogp_1200x630.jpg?1559214352',
    description: `Our guest in Part 19 of OWNDAYS MEETS is Ototake Hirotada. We speak him about the “OTOTAKE PROJECT” in which he took up the challenge of walking with prosthetic legs developed using the latest technology. We also talk to him about his plans moving forward.`,
    canonicalUrl: `${baseCanonicalUrl}/owndays-meets-201905`,
  },
  {
    metaTitle: 'OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/owndays-meets-201402',
    keywords:
      'AKIYO NOGUCHI,OWNDAYS MEETS,glasses,spectacles,optical shop,eyeglasses,OWNDAYS,frame,sunglasses,eyewear Singapore',
    ogImage:
      'https://www.owndays.com/images/specials/owndays-meets/201402/ogp_1200x630.jpg?1553872749',
    description: `#03 AKIYO NOGUCHI -OWNDAYS MEETS- Own Days… Each day builds on the last, and eventually they from one path.`,
    canonicalUrl: `${baseCanonicalUrl}/owndays-meets-201403`,
  },
  {
    metaTitle: 'BLACK COLLECTION | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/black-collection',
    keywords:
      'black collection,black,collection,glasses,spectacles,optical shop,online store,eyeglasses,OWNDAYS,frame,sunglasses,pc lenses,Singapore',
    ogImage: null,
    description: `Discover the Black Collection, a range of eyewear designed to make a bold statement.`,
    canonicalUrl: `${baseCanonicalUrl}/black-collection`,
  },
  {
    metaTitle:
      'Memory Metal | Great Elasticity and Durability, The New Standards of Spectacle Frames | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/memorymetal',
    keywords:
      'memorymetal,memory,metal,glasses,spectacles,optical shop,online store,eyeglasses,OWNDAYS,frame,sunglasses,pc lenses,Singapore',
    ogImage: null,
    description: `Discover the Memory Metal Collection, a range of eyewear designed to make a bold statement.`,
    canonicalUrl: `${baseCanonicalUrl}/memorymetal`,
  },
  {
    metaTitle: 'TOY STORY | OWNDAYS | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/toystory',
    keywords:
      'TOY STORY,collaboration,eyeglasses,snap,sunglasses,woody,buzz lightyear,jessie,rex,lotso,aliens,bo peep,potato head,slinky dog,sid phillips,merchandise,disney,pixar,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/owndays/img/toystory/ogp_1200x630.webp',
    description: `Do you remember your first toy? What about your favourite one? Step into the TOY STORY | OWNDAYS eyewear collection where imagination and childhood joy come to life once again. Inspired by the beloved Disney Pixar Toy Story characters, the collection features 12 models, each capturing the unique charm of Woody, Buzz Lightyear, Jessie, Rex, Bo Peep and more! Each frame comes with a themed spectacle case and lens cleaning cloth, available in two designs featuring best friends, Woody and Buzz Lightyear. Let’s Bring Back the Moment with the TOY STORY | OWNDAYS collection today.`,
    canonicalUrl: `${baseCanonicalUrl}/toystory`,
    otherScript: fancyBoxScript,
  },
  {
    metaTitle: 'SQUID GAME × OWNDAYS | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/squid-game',
    keywords: 'SQUID GAME,Netflix,Yonghee,collaboration,eyeglasses,onlinestore,OWNDAYS,Singapore',
    description: `Netflix worldwide hit drama series "SQUID GAME", collaborated with OWNDAYS! Dreaming of striking it rich, contestants risk everything in a high-stakes game in the gripping Netflix series SQUID GAME. We’ve captured its unique world through distinctive six frame design inspired by the show’s iconic imagery. The items are available to enhance your enjoyment of the latest season its coming. Wear the collaboration eyewear and join the “SQUID GAME”!`,
    ogImage: `https://static.lenskart.com/owndays/img/squid-game/ogp_1200x630.webp`,
    canonicalUrl: `${baseCanonicalUrl}/squid-game`,
  },
  {
    metaTitle: 'OWNDAYS | MOVE | Eyewear for the active | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/move',
    keywords:
      'MOVE,OWNDAYS | MOVE,sports,active,lens,eyeglasses,eyewear,sunglasses,OWNDAYS,Singapore',
    ogImage: 'https://static.lenskart.com/owndays/img/move/ogp_1200x630.webp',
    description: `Designed for a secure fit that stays in place even during active movement. Perfect for everyday life and on-the-go moments.`,
    canonicalUrl: `${baseCanonicalUrl}/move`,
    otherScript: fancyBoxScript,
  },
  {
    metaTitle: 'Junni（Kids Glasses）| OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/news/junni',
    keywords: 'kids,children,junior,glasses,eyewear,Junni,OWNDAYS',
    ogImage: 'https://static.lenskart.com/owndays/img/junni/ogp_1200x630.webp',
    description: `A kids’ eyewear collection born from the belief that fashion isn’t just for grown-ups. Thoughtfully crafted for comfort and the perfect fit, each frame is designed with a playful spirit and a child-friendly touch.`,
    canonicalUrl: `${baseCanonicalUrl}/junni`,
  },
];
